import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import './Services.css';
import latheImg from './images/puma-2600.webp';
import millingImg from './images/VMX42Ui.webp';
import grindingImg from './images/Z48.webp';
import controlImg from './images/3D.webp';
import { ArrowIcon, Reveal, SplitText } from './motion';
import { MACHINE_CATEGORIES } from '../data/machines';

// Obrázky se zobrazují jen jako malé náhledy na mobilu.
const SERVICES = [
  { key: 'lathe', image: latheImg },
  { key: 'milling', image: millingImg },
  { key: 'grinding', image: grindingImg },
  { key: 'control', image: controlImg },
];

const Services = () => {
  const { t } = useTranslation();
  const [active, setActive] = useState(null);

  return (
    <section id="services" className="section section--dark services">
      <div className="container">
        <div className="section-head section-head--split">
          <div className="section-head">
            <SplitText text={t('services.title')} className="section-head__title" />
          </div>
          <Reveal as="p" className="section-head__desc" delay={0.15}>
            {t('services.desc')}
          </Reveal>
        </div>

        <ul className="svc-list" onPointerLeave={() => setActive(null)}>
          {SERVICES.map((s, i) => (
            <Reveal as="li" key={s.key} delay={i * 0.08} y={30}>
              <Link
                to={MACHINE_CATEGORIES[s.key].path}
                className={`svc-row ${active !== null && active !== i ? 'is-dimmed' : ''}`}
                onPointerEnter={() => setActive(i)}
              >
                <h3 className="svc-row__title">{t(`services.${s.key}.name`)}</h3>
                <p className="svc-row__desc">{t(`services.${s.key}.desc`)}</p>
                <span className="svc-row__more">
                  <span>{t('services.more')}</span>
                  <ArrowIcon />
                </span>
                <img className="svc-row__thumb" src={s.image} alt="" loading="lazy" />
              </Link>
            </Reveal>
          ))}
        </ul>
      </div>
    </section>
  );
};

export default Services;
